import styled from '@emotion/styled';
import { layers } from 'app/spacing';

export const GRADIENT_Z_INDEX = layers.content(0, 2);
export const CYCLE_SELECT_MENU_Z_INDEX = layers.content(0, 4);

export const ModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 40px 0px 40px;
  width: 100%;
`;

export const InitialLoadOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: ${layers.content(0, 3)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-background-white);
`;

const TABLE_HEADER_HEIGHT = 50;

export const TableScrollArea = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;

  & table {
    width: 100%;
    min-width: 0;
    flex-shrink: 0;
    align-self: flex-start;
    table-layout: auto;
  }
`;

export const LoaderOverlay = styled.div`
  position: absolute;
  top: ${TABLE_HEADER_HEIGHT}px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorOverlay = styled.div`
  position: absolute;
  top: ${TABLE_HEADER_HEIGHT}px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 20px;
`;

export const TabPanel = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? 'flex' : 'none')};
  flex: 1;
  flex-direction: column;
  min-height: 0;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const SEARCH_PILL_WIDTH = 160;

export const SearchToggle = styled.div<{ active: boolean }>`
  display: ${({ active }) => (active ? 'inline-flex' : 'none')};

  & > div {
    width: ${SEARCH_PILL_WIDTH}px;
  }
`;
